import { AppConsts } from '@shared/AppConsts';
import { Component, Injector, ViewEncapsulation, ViewChild, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { CustomerPaymentsServiceProxy, CustomerPaymentDto, Status, PaymentStatus, EntityDto, CommonLookupServiceProxy, DropDownLookupDto } from '@shared/service-proxies/service-proxies';
import { NotifyService } from 'abp-ng2-module';
import { AppComponentBase } from '@shared/common/app-component-base';
import { TokenAuthServiceProxy } from '@shared/service-proxies/service-proxies';

import { appModuleAnimation } from '@shared/animations/routerTransition';
import { Table, TableModule } from 'primeng/table';
import { Paginator, PaginatorModule } from 'primeng/paginator';
import { LazyLoadEvent, PrimeTemplate } from 'primeng/api';
import { FileDownloadService } from '@shared/utils/file-download.service';
import { filter as _filter } from 'lodash-es';
import { DateTime } from 'luxon';
import { UtilsService } from 'app/shared/common/utils/utils-service';
import { DateTimeService } from '@app/shared/common/timing/date-time.service';

import { HttpClient } from '@angular/common/http';
import { FileUpload, FileUploadModule } from 'primeng/fileupload';
import { finalize } from 'rxjs';

import { ExcelColumnSelectionModalComponent } from '@app/shared/common/excel-column-selection/excel-column-selection-modal';
import * as moment from 'moment';

@Component({
    templateUrl: './customerPayments.component.html',
    encapsulation: ViewEncapsulation.None,
    animations: [appModuleAnimation()],
    standalone: false,
})
export class CustomerPaymentsComponent extends AppComponentBase {
    @ViewChild('dataTable', { static: true }) dataTable: Table;
    @ViewChild('paginator', { static: true }) paginator: Paginator;

    @ViewChild('ExcelFileUpload', { static: false }) excelFileUpload: FileUpload;

    @ViewChild('excelColumnSelectionModal', { static: true })
    excelColumnSelectionModal: ExcelColumnSelectionModalComponent;

    advancedFiltersAreShown = false;
    filterText = '';

    customerDisplayPropertyFilter = '';
    paymentTypeNameFilter = '';
    paymentStatus = PaymentStatus

    uploadUrl: string;
    allCustomers: DropDownLookupDto[];
    allPaymentTypes: DropDownLookupDto[];
    allStatus: DropDownLookupDto[];
    customerId: 0;
    paymentTypeId: 0;
    dateRangeSelected = false;
    receiptNo: '';
    invoiceNo: '';
    referenceNo: '';
    invoiceStatus = 0;
    dateRange: Date[] = [];
    constructor(
        injector: Injector,
        private _customerPaymentsServiceProxy: CustomerPaymentsServiceProxy,
        private _notifyService: NotifyService,
        private _tokenAuth: TokenAuthServiceProxy,
        private _activatedRoute: ActivatedRoute,
        private _fileDownloadService: FileDownloadService,
        private _router: Router,
        private _dateTimeService: DateTimeService,
        private _httpClient: HttpClient,
        public utilsService: UtilsService,
         private _commonLookupServiceProxy: CommonLookupServiceProxy,
    ) {
        super(injector);

        this.uploadUrl = AppConsts.remoteServiceBaseUrl + '/CustomerPayments/ImportFromExcel';
    }

    ngOnInit(): void {
        this.initializeDateRange();
        this.populateDropDowns();
    }



    initializeDateRange() {
        const today = new Date();
        this.dateRange = [
            new Date(today.getFullYear(), today.getMonth(), today.getDate()),
            new Date(today.getFullYear(), today.getMonth(), today.getDate())
        ];
    }

    OnselectDateRange(event: Event) {
        const isChecked = (event.target as HTMLInputElement).checked;
        this.dateRangeSelected = isChecked;

    }


    printVoucher(id: number): void {
        window.open(AppConsts.remoteServiceBaseUrl + '/Account/JournalVoucher/' + id, '_blank');
    }

    setDateRange(type: string) {
        const today = new Date();
        let start: Date, end: Date;

        switch (type) {
            case 'today':
                start = end = today;
                break;
            case '7days':
                start = new Date();
                start.setDate(today.getDate() - 6);
                end = today;
                break;
            case '30days':
                start = new Date();
                start.setDate(today.getDate() - 29);
                end = today;
                break;
            case 'thisMonth':
                start = new Date(today.getFullYear(), today.getMonth(), 1);
                end = new Date(today.getFullYear(), today.getMonth() + 1, 0);
                break;
            case 'lastMonth':
                start = new Date(today.getFullYear(), today.getMonth() - 1, 1);
                end = new Date(today.getFullYear(), today.getMonth(), 0);
                break;
            default:
                start = end = today;
        }

        this.dateRange = [start, end];
    }

    populateDropDowns() {
        this._commonLookupServiceProxy.getAllCustomerForTableDropdown().subscribe((result) => {
            this.allCustomers = result;
            this.customerId = 0;
        });

        this._commonLookupServiceProxy.getAllPaymentTypesForTableDropdown().subscribe((result) => {
            this.allPaymentTypes = result;
            this.paymentTypeId = 0;
        });

        this._commonLookupServiceProxy.getAllPurchaseInvoiceStatusForTableDropdown().subscribe((result) => {
            this.allStatus = result;
            this.invoiceStatus = 0;
        });
    }

    getCustomerPayments(event?: LazyLoadEvent) {
        if (this.primengTableHelper.shouldResetPaging(event)) {
            this.paginator.changePage(0);
            if (this.primengTableHelper.records && this.primengTableHelper.records.length > 0) {
                return;
            }
        }

        this.primengTableHelper.showLoadingIndicator();
        const startDate = moment(this.dateRange[0]).format('YYYY-MM-DD');
        const endDate = moment(this.dateRange[1]).format('YYYY-MM-DD');
        this._customerPaymentsServiceProxy
            .getAll(
                this.customerId,
                this.paymentTypeId,
                this.invoiceNo,
                this.receiptNo,
                this.referenceNo,
                this.dateRangeSelected,
                startDate ? DateTime.fromISO(startDate) : undefined,
                endDate ? DateTime.fromISO(endDate) : undefined,
                this.appSession.user.locationId,
                this.primengTableHelper.getSorting(this.dataTable),
                this.primengTableHelper.getSkipCount(this.paginator, event),
                this.primengTableHelper.getMaxResultCount(this.paginator, event),
            )
            .subscribe((result) => {
                this.primengTableHelper.totalRecordsCount = result.totalCount;
                this.primengTableHelper.records = result.items;
                this.primengTableHelper.hideLoadingIndicator();
            });
    }

    reloadPage(): void {
        this.paginator.changePage(this.paginator.getPage());
    }

    createCustomerPayment(): void {
        this._router.navigate(['/app/sales/customerPayments/createOrEdit']);
    }

    deleteCustomerPayment(customerPayment: CustomerPaymentDto): void {
        this.message.confirm('', this.l('AreYouSure'), (isConfirmed) => {
            if (isConfirmed) {
                this._customerPaymentsServiceProxy.delete(customerPayment.id).subscribe(() => {
                    this.reloadPage();
                    this.notify.success(this.l('SuccessfullyDeleted'));
                });
            }
        });
    }

    exportToExcel($event): void {
        this._customerPaymentsServiceProxy
            .getCustomerPaymentsToExcel(
                this.filterText,
                $event,
                this.customerDisplayPropertyFilter,
                undefined,
                this.paymentTypeNameFilter,
                undefined,
            )
            .subscribe((result) => {
                this._fileDownloadService.downloadTempFile(result);
            });
    }

    uploadExcel(data: { files: File }): void {
        const formData: FormData = new FormData();
        const file = data.files[0];
        formData.append('file', file, file.name);

        this._httpClient
            .post<any>(this.uploadUrl, formData)
            .pipe(finalize(() => this.excelFileUpload.clear()))
            .subscribe((response) => {
                if (response.success) {
                    this.notify.success(this.l('ImportCustomerPaymentsProcessStart'));
                } else if (response.error != null) {
                    this.notify.error(this.l('ImportCustomerPaymentsUploadFailed'));
                }
            });
    }

    onUploadExcelError(): void {
        this.notify.error(this.l('ImportCustomerPaymentsUploadFailed'));
    }

    resetFilters(): void {
        this.receiptNo = '';
        this.invoiceNo = '';
        this.referenceNo = '';
        this.customerId = 0;
        this.paymentTypeId = 0;

        this.getCustomerPayments();
    }

    showExcelColumnSelectionModal() {
        this._customerPaymentsServiceProxy.getCustomerPaymentExcelColumnsToExcel().subscribe((result) => {
            this.excelColumnSelectionModal.show(result);
        });
    }

    convertToDraft(customerPayment: CustomerPaymentDto): void {

        this.message.confirm('', this.l('AreYouSure'), (isConfirmed) => {
            if (isConfirmed) {
                this.primengTableHelper.showLoadingIndicator();
                var entitDto = new EntityDto();
                entitDto.id = customerPayment.id;
                this._customerPaymentsServiceProxy.convertCustomerPaymentToDraft(entitDto).subscribe(() => {
                    this.getCustomerPayments({});
                    this.notify.success(this.l('SuccessfullyDraft'));
                    this.primengTableHelper.hideLoadingIndicator();
                });
            }
        });
    }

    convertToPayment(customerPayment: CustomerPaymentDto): void {
        this.message.confirm('', this.l('AreYouSure'), (isConfirmed) => {
            if (isConfirmed) {
                var entitDto = new EntityDto();
                this.primengTableHelper.showLoadingIndicator();
                entitDto.id = customerPayment.id;
                this._customerPaymentsServiceProxy.convertDraftToCustomerPayment(entitDto).subscribe(() => {
                    this.getCustomerPayments({});
                    this.notify.success(this.l('SuccessfullyConvertedToPayment'));
                    this.primengTableHelper.hideLoadingIndicator();
                });
            }
        });
        
    }
}
